import React from "react";
import CTASection from "../CTASection/CTASection";
import styles from "./PlasticMoulding.module.css";
import plasticMouldingBg from "../../../../images/PlasticMoulding.jpg";

export default function PlasticMoulding() {
  return (
    <section className={styles.section} id="plastic-moulding">
      <div className={styles.imageArea}>
        <img
          className={styles.bgImage}
          src={plasticMouldingBg}
          alt="Plastic Moulding"
          loading="lazy"
        />
        <div className={styles.overlay} aria-hidden="true" />
        <div className={styles.content}>
          <div className={styles.inner}>
            <span className={styles.eyebrow}>Plastic Moulding</span>
            <h2 className={styles.title}>Plastic Moulding</h2>
            <p className={styles.description}>
              Product development, mould manufacturing, injection moulding & high precision moulding.
            </p>
          </div>
        </div>
      </div>
      <CTASection
        title="Know more about Plastic Moulding"
        description="Product Development, Mould Manufacturing, Assembly Jobs and Development"
        label="Know More..."
        subLabel="about PM"
        href="/plastic-moulding"
      />
    </section>
  );
}
